
import {TableCell} from "@material-ui/core";
import {SequenceDisplay} from "core/Display";
import React from "react";
import styled from "styled-components";

import CargoWeight from "../Parts/CargoWeight";
const StyledTableCell = styled(TableCell)`
  font-size: 12px;
  vertical-align: top;
  min-width: 150px;
`;


export default function TableCellCargo({item}) {
  return (
    <StyledTableCell>
      {item.container_number && (
        <div>{item.container_number}</div>
      )}
      <SequenceDisplay values={[
        item.container_type ? item.container_type.name : undefined,
        item.container_owner_display,
      ]} separator={', '} defaults={''} />
      {item.cargo_weight && (
        <div>Вес: <CargoWeight item={item} /></div>
      )}
    </StyledTableCell>
  )
}

